<script setup>
    import { ref } from "vue";
    import FormCheckBox from "./FormCheckBox.vue";
    import FormCardCheckBox from "./FormCardCheckBox.vue";

    const form = ref({
        services: [],
        servicest: [],
    });
</script>

<template>
    <form>
        <div class="container">
            <div class="row gy-4">
                <div class="col-12">
                    <div class="row">
                        <div class="col-4">
                            <h3 class="h3">Maak een keuze</h3>
                            <p>Certe, inquam, pertinax non emolumento aliquo, sed et iusto odio.</p>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <FormCardCheckBox
                        id="service-website-or-webshop"
                        value="Website of webwinkel"
                        v-model="form.services"
                        icon-class="fad fa-lightbulb-on"
                        title="Website of webwinkel"
                        image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjF8fGlkZWF8ZW58MHx8MHw%3D&amp;ixlib=rb-1.2.1&amp;auto=format&amp;fit=crop&amp;w=500&amp;q=60"
                    >
                        Laat je business groeien! We denken samen met je mee over jouw online kansen.
                    </FormCardCheckBox>
                </div>

                <div class="col-3">
                    <FormCardCheckBox
                        id="service-marketing"
                        value="Marketing"
                        v-model="form.services"
                        icon-class="fad fa-analytics"
                        title="Marketing"
                        image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjF8fGlkZWF8ZW58MHx8MHw%3D&amp;ixlib=rb-1.2.1&amp;auto=format&amp;fit=crop&amp;w=500&amp;q=60"
                    >
                        Je bedrijf beter op de markt zetten, of de juiste doelgroep bereiken? Wij denken met je mee.
                    </FormCardCheckBox>
                </div>

                <div class="col-3">
                    <FormCardCheckBox
                        id="service-seo"
                        value="SEO"
                        v-model="form.services"
                        icon-class="fad fa-tachometer-alt-fastest"
                        title="SEO"
                        image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjF8fGlkZWF8ZW58MHx8MHw%3D&amp;ixlib=rb-1.2.1&amp;auto=format&amp;fit=crop&amp;w=500&amp;q=60"
                    >
                        Al een bestaande website? We helpen je graag om deze beter vindbaar te maken in Google.
                    </FormCardCheckBox>
                </div>

                <div class="col-3">
                    <FormCardCheckBox
                        id="service-other"
                        value="Overig"
                        v-model="form.services"
                        icon-class="fad fa-gift"
                        title="Overig"
                        image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjF8fGlkZWF8ZW58MHx8MHw%3D&amp;ixlib=rb-1.2.1&amp;auto=format&amp;fit=crop&amp;w=500&amp;q=60"
                    >
                        Staat je keuze hier niet tussen? Geen probleem, we staan voor je klaar.
                    </FormCardCheckBox>
                </div>
            </div>
        </div>
    </form>
</template>

<style scoped>

</style>